import { useMemo } from 'react'
import { useRecoilValue } from 'recoil'

import { kpiParameterAtom } from '../recoil/navigation/atoms'
import { mustacheParameterAtom } from '../recoil/records/atoms'
import { usePeriod } from './usePeriod'

export function useMustacheParameter() {
  const raw = useRecoilValue(mustacheParameterAtom)
  const kpiPivotParameter = useRecoilValue(kpiParameterAtom) // この2つのatomはマージするべきものか？
  const [period] = usePeriod()

  return useMemo(
    () => ({
      ...raw,
      ...kpiPivotParameter.queryParameter,
      // date_trunc('month', current_date) のような値をparameterに保存しようかとも思ったが、SQLを書いてしまうとDestinationの差異の対応が大変
      // また、toISOString()を初期は考えていたが、startAtをそのまま文字列で埋め込むので、タイムゾーンでおかしくなるためやめる
      startAt: period?.startAt?.format(`YYYY-MM-DD HH:mm:ss`) ?? kpiPivotParameter.queryParameter?.startAt,
      endAt: period?.endAt?.format(`YYYY-MM-DD HH:mm:ss`) ?? kpiPivotParameter.queryParameter?.endAt,
    }),
    [raw, kpiPivotParameter.queryParameter, period?.startAt, period?.endAt],
  )
}
